import { Select, Form, Spin } from 'antd'
import React, { useEffect, useState , useRef } from 'react'
import './index.scss'
import { SpinnerIco } from "../../../modules/CustomIcons";
import errorStatus from "assets/images/icons/errorStatus.svg";
import CustomTooltip from "components/Tooltip";
import { useTranslation } from 'react-i18next';
import {log} from "util";
const { Option } = Select



const SelectField = (props: any) => {
  const selectRef = useRef<any>(null);
  const enclosingForm = Form.useFormInstance();
  const {t} = useTranslation()
  const [value, setValue] = useState(props.value || '');

  const [noHover, setHover] = useState(false)
  const [disabled, setDisabled] = useState<boolean>(props.disabled || false)
  const [selected,setSelected] = useState(false)
  const [openStatus, setOpenStatus] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const input_name = props.name || '';

  useEffect(() => {
    if (!props.keepSearchValueOnSelect || !props.showSearch || !props.value) {
      return;
    }

    const match = props.options?.find((row: any) =>
      (props.kod ? row.value + row.cardHolder : row.value) === props.value
    );

    if (match) {
      setSearchValue(match.label);
    }
  }, [props.value, props.keepSearchValueOnSelect]);

  const updateValue = (value) => {

    setValue(() => value);

    if (props.form) {
      props.form.setFieldsValue(
        {
          [input_name]: value
        }
      );
    }
  }

  useEffect(() => {
    updateValue(props.value);

    setDisabled(old_data => props.disabled)

  }, [props.value, props.disabled, props.options, props.disabled]);

  const onChange = (value: any) => {
  if (props.onChange) {
    props.onChange(value);
  }

  updateValue(value);

  if(props.transferType){
    setSelected(true);
  }
}

const getOptionLabel = (option: any) => {
  if (typeof option?.label === "string") {
    return option.label;
  }

  if (typeof option?.children === "string") {
    return option.children;
  }

  return "";
};

  let validate_message = props.message || '';

  if (props.required && !props.message) {
    validate_message = t("newTransfer.requiredField");
  }

  const onDropdownVisibleChange = (open) => {
  setOpenStatus(open);

  if (open) {
    setSelected(false);

    setTimeout(() => {
      document
        .querySelector('.ant-select-item.ant-select-item-option')
        ?.classList.remove('ant-select-item-option-active');
    });
  }
};

  const onReset = () => {

    onChange('');

    if (props.keepSearchValueOnSelect && props.showSearch) {
      setSearchValue('');
    }

    let current_input = document.querySelector(`#${input_name}`);

    if (current_input?.classList.contains('isDisabled')) {
      setDisabled(old_data => true)
    }

  }

  const notFoundContent = (
    <div className={'flex justify_center select_loading'}>
      {props.notFoundContent ?? <Spin indicator={<SpinnerIco />} />}
    </div>
  );

  return (
    <Form.Item
      name={input_name}
      labelCol={props.labelCol}
      wrapperCol={props.wrapperCol}
      className={props.className}
      label={props.labelItem}
      validateStatus={props.notValid}
      rules={[{ required: props.required || false, message: validate_message }]}
      onReset={onReset}
      shouldUpdate={(prevValues, curValues) => {

        if (prevValues[input_name] !== curValues[input_name]) {
          setDisabled(old_value => props.disabled)
        }

        return true;
      }}
    >

      <Select
        ref={selectRef}
        placeholder={props.placeholder || t("transfers.select")}
        optionFilterProp={value}
        showSearch={props.showSearch || false}
        searchValue={props.showSearch ? searchValue : undefined}
        onSearch={(value) => {
        if (props.keepSearchValueOnSelect && value === '' && !openStatus && searchValue !== '') {
          return;
        }
        setSearchValue(value);
        props.onSearch?.(value);
        if (props.keepSearchValueOnSelect && props.showSearch && value === '') {
          onChange('');
          (props.form || enclosingForm)?.setFieldsValue({ [input_name]: '' });
        }
        }}
        dropdownStyle={props.dropdownStyle}
        size="large"
        open={props.open}
        filterOption={props.filterOption}
        style={props.width ? { width: props.width } : (props.height ? { height: props.height } : {})}
        onSelect={(selectedValue, option) => {
        onChange(selectedValue);
        if (props.keepSearchValueOnSelect && props.showSearch) {
        setSearchValue(getOptionLabel(option));
  }
}}
        onMouseLeave={() => setHover(true)}
        onMouseEnter={() => setHover(false)}
        disabled={disabled}
        // dropdownClassName={props.dropdownClassName}
        dropdownClassName={`${noHover  ? "" : "hoverable "} ${props.dropdownClassName}`}
        defaultActiveFirstOption={props.defaultActiveFirstOption || false}
        /*value={value}*/
        optionLabelProp={props.optionLabelProp || "label"}
        defaultValue={props?.defaultValue}
        labelInValue={props.labelInValue}
        allowClear={props.allowClear || false}
        onDropdownVisibleChange={onDropdownVisibleChange}
        getPopupContainer={trigger => trigger.parentElement?.parentElement?.parentElement?.parentElement?.parentElement?.parentElement.parentElement.parentElement}
        // getPopupContainer={() => document.body}
        dropdownMatchSelectWidth={false}
        notFoundContent={notFoundContent}

      >
        {

          props.options?.map((row: any, index: number) => {
            return (
              <Option key={index} className={'hesabsec'} value={props.kod ? row.value + row.cardHolder:row.value} label={row.label} >

                <div className='selectSpan-wrapper' style={{width: "100%"}}>
                  
                    {row.title && <span className={'selectListTitle'}>{ !openStatus ? row.title?.trim() : row.title}</span>}
                    { props.page ? row.label :
                        props.headerCheck ? ( (row.title?.trim() == '' || openStatus) ? (<span className='spansearched'> { props.label !== '' ? row.label : row.value}
                      {row.status === "0" && <CustomTooltip className={'hesablar'} title={t("transfers.closedAccount")}>
                        <img style={{ marginLeft: 30 }} src={errorStatus} />
                      </CustomTooltip>} </span>) : <></>) : (<span className={'selectSpan'}> { props.label !== '' && !selected ? row.label : row.value}
                          {row.status === "0" && <CustomTooltip title={t("transfers.closedAccount")}>
                            <img style={{ marginLeft: 30 }} src={errorStatus} />
                          </CustomTooltip>} </span>)

                    }
                    {
                      (row.status === "0" && props.masstransfer) && <span><CustomTooltip className={'hesablar'} title={t("transfers.closedAccount")}>
                      <img style={{ marginLeft: 30 }} src={errorStatus} />
                    </CustomTooltip> </span>
                    }
                  </div>
                {row.extra && (openStatus || props.account) && (props.transfer !== true || (props.transfer === true && value !== row.value)) && <span className='extraspan'>{row.extra}</span>}
              </Option>
            )
          })
        }
      </Select>
    </Form.Item>
  )
}

export default SelectField
